import { track } from '@vercel/analytics';
import { isTermlyCategoryConsented } from './termlyConsent';

function trackWithConsent(event: string, data?: Record<string, string | number | boolean>) {
  if (!isTermlyCategoryConsented('analytics')) {
    return;
  }
  if (data) {
    track(event, data);
  } else {
    track(event);
  }
}

// Custom event tracking for key user actions
export const trackEvent = {
  // Authentication events
  signUp: (method: string = 'email', properties?: Record<string, string>) => {
    trackWithConsent('sign_up', { method, ...properties });
  },

  signIn: (method: string = 'email') => {
    trackWithConsent('sign_in', { method });
  },

  signOut: () => {
    trackWithConsent('sign_out');
  },

  // Age verification events
  ageVerified: (age: number, state?: string) => {
    trackWithConsent('age_verified', {
      ageGroup: age >= 18 ? '18+' : age >= 14 ? '14-17' : 'under-14',
      ...(state && { state }),
    });
  },

  parentalConsentRequired: () => {
    trackWithConsent('parental_consent_required');
  },

  // School selection events
  schoolViewed: (schoolId: string, schoolName: string) => {
    trackWithConsent('school_viewed', { schoolId, schoolName });
  },

  schoolAdded: (schoolId: string, schoolName: string) => {
    trackWithConsent('school_added_to_list', { schoolId, schoolName });
  },

  schoolRemoved: (schoolId: string, schoolName: string) => {
    trackWithConsent('school_removed_from_list', { schoolId, schoolName });
  },

  // Profile events
  profileCompleted: (completionPercentage: number) => {
    trackWithConsent('profile_completed', { completionPercentage });
  },

  profileUpdated: (section: string) => {
    trackWithConsent('profile_updated', { section });
  },

  // Navigation events
  pageView: (pageName: string) => {
    trackWithConsent('page_view', { page: pageName });
  },

  // Conversion events
  subscriptionStarted: (plan: string, price: number) => {
    trackWithConsent('subscription_started', { plan, price });
  },

  // Error events (supplement Sentry)
  errorOccurred: (errorType: string, context?: string) => {
    trackWithConsent('error_occurred', { errorType, ...(context && { context }) });
  },
};
